import Stories from "../library/StoryGroup";
import { usePublic, useUser } from "contexts";

export function Favorites() {
  const { loading, all: collection } = usePublic();
  const { profile } = useUser();

  return (
    <Stories
      books={profile.favorites
        ?.map((id) => collection.find((book) => book._id === id))
        .slice(0, 7)}
      hidden={loading || !profile.favorites?.length}
      orientation="portrait"
      scrollable
    />
  );
}
